import React from 'react';
import { ArcStack } from '@src/core/ui';
import { OrdersWrapperView, ToggleCollapseView } from '@src/features/order/pages/orders-page/components';
import { NewSectionProps } from './types';
import { ArcOrderCard } from '@src/core/components';
import { OrderStatusEnum } from '@src/features/order/entities';

const NewSection: React.FC<NewSectionProps> = (props) => {
  const { orders, selected, onSelectOrder, count } = props;

  return (
    <ArcStack direction='column' width='20%' height='100%' sx={{ display: 'flex', flexDirection: 'column' }}>
      <ToggleCollapseView 
        count={count}
        status={OrderStatusEnum.NEW}>
        <OrdersWrapperView>
          {orders.map((order, index) => (
            <ArcOrderCard
              key={order.id} 
              order={order}
              fullWidth={false}
              isSelected={order.id === selected?.id}
              onClick={() => onSelectOrder(order, OrderStatusEnum.NEW)}
              index={index}
              status={OrderStatusEnum.NEW}
              sx={{ width: '100%', minHeight:'110px' }}
            />
          ))}
        </OrdersWrapperView>
      </ToggleCollapseView>
    </ArcStack>
  );
};

export default NewSection;